import type { PaymentMethod } from '@brighterly/lib-core-types/payments/interfaces'
import type { PaymentProvider } from '@brighterly/lib-core-types/subscription/enums'

import { toAnalyticsId } from '@shared/lib/amplitude'

interface PaymentProviderEventProps {
  payment_provider: string | null
}

interface PaymentMethodEventProps extends PaymentProviderEventProps {
  payment_method: string | null
  card_brand: string | null
}

/** `payment_provider` as the registry wants it: the provider id in lowercase (`solidgate`, `stripe`). */
export const providerEventProps = (provider: PaymentProvider | null | undefined): PaymentProviderEventProps => ({
  payment_provider: provider?.toLowerCase() ?? null,
})

/** A saved payment method without its card data: type, brand and provider only. */
export const paymentMethodEventProps = (method: PaymentMethod | null | undefined): PaymentMethodEventProps => ({
  payment_method: method?.type ? toAnalyticsId(method.type) : null,
  card_brand: method?.details?.brand ? toAnalyticsId(method.details.brand) : null,
  ...providerEventProps(method?.provider),
})
